// exportInscritosLogic.js (ejemplo simplificado)

import { exportFull } from './exportFull';
import { exportMeetD } from './exportMeetD';
import { exportMeetI } from './exportMeetI';
import { exportMeetQ } from './exportMeetQ';
import { exportCustomLogic } from './exportCustomLogic';

export function handleExportLogic({
  exportType,
  meetReportType,
  selectedFields,
  inscripciones,
  competitionName,
  competitionId,
  relayEntries,
  delimiter,
  forceQuoted,
}) {
  if (exportType === 'full') {
    exportFull({
      inscripciones,
      competitionName,
      competitionId,
      delimiter,
      forceQuoted,
    });
  } else if (exportType === 'hytek') {
    // Forzamos delimiter=';' y forceQuoted=false
    switch (meetReportType) {
      case 'D':
        exportMeetD(inscripciones, competitionName);
        break;
      case 'I':
        exportMeetI(inscripciones, competitionName);
        break;
      case 'Q':
        exportMeetQ(inscripciones, competitionName);
        break;
      default:
        break;
    }
  } else if (exportType === 'custom') {
    exportCustomLogic({
      inscripciones,
      selectedFields,
      competitionName,
      delimiter,
      forceQuoted,
    });
  }
}
